import CompletedConfirmationModal from './CompletedConfirmationModal';

export default CompletedConfirmationModal;
